import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MemberWithUser } from '../../core/services/org.service';

@Component({
  selector: 'app-member-picker',
  templateUrl: './member-picker.component.html',
})
export class MemberPickerComponent implements OnChanges {
  /** All available active org members to pick from. */
  @Input() members: MemberWithUser[] = [];
  /** Currently selected userIds. */
  @Input() selectedIds: string[] = [];
  /** Emits the full updated selectedIds array whenever the selection changes. */
  @Output() selectedIdsChange = new EventEmitter<string[]>();
  /** Whether editing is allowed. */
  @Input() readOnly = false;

  searchQuery = '';
  dropdownOpen = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['members']) {
      this.searchQuery  = '';
      this.dropdownOpen = false;
    }
  }

  get selectedMembers(): MemberWithUser[] {
    return this.members.filter(m => this.selectedIds.includes(m.userId));
  }

  get availableMembers(): MemberWithUser[] {
    const q       = this.searchQuery.toLowerCase().trim();
    const notSelected = this.members.filter(m => !this.selectedIds.includes(m.userId));
    if (!q) return notSelected;
    return notSelected.filter(m =>
      `${m.givenName} ${m.familyName}`.toLowerCase().includes(q) ||
      m.email.toLowerCase().includes(q),
    );
  }

  displayName(m: MemberWithUser): string {
    const full = `${m.givenName} ${m.familyName}`.trim();
    return full || m.email;
  }

  add(member: MemberWithUser): void {
    if (this.readOnly || this.selectedIds.includes(member.userId)) return;
    this.selectedIdsChange.emit([...this.selectedIds, member.userId]);
    this.searchQuery = '';
  }

  remove(userId: string): void {
    if (this.readOnly) return;
    this.selectedIdsChange.emit(this.selectedIds.filter(id => id !== userId));
  }

  openDropdown(): void {
    if (!this.readOnly) this.dropdownOpen = true;
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  onSearchFocus(): void {
    this.openDropdown();
  }
}
